import React from "react";
import { Modal } from "../../../../Modal/Default/Index";
import { AlertModal } from "../../../../Modal/Alert/Index";
import { RoundedCloseButton } from "../../../../Buttons/RoundedCloseButton/Index";
import { ButtonOnlyTitle } from "../../../../Buttons/ButtonOnlyTitle/Index";
import { ButtonWithChildren } from "../../../../Buttons/ButtonWithChildren/Index";
import { TitleModal } from "../../../../Modal/Contents/TitleModal/Index";
import { TextModal } from "../../../../Modal/Contents/TextModal/Index";
import { ReactComponent as Check } from "../../../../../assets/svg/icons/CheckFull.svg";
import { ReactComponent as PositiveIcon } from "../../../../../assets/svg/icons/positive.svg";
import { ReactComponent as NegativeIcon } from "../../../../../assets/svg/icons/negative.svg";
import "./styles.css";
import { useTranslation } from "react-i18next";

interface SuccessModalCreateProductProps {
  visible: boolean;
  onClose: () => void;
  backScreen: () => void;
  newProduct: () => void;
}

interface DeleteModalCreateProductProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const deleteModalContentStyle = {
  width: "600px",
  height: "345px",
  borderRadius: "25px",
} as React.CSSProperties;

export const SuccessModalCreateProduct: React.FC<SuccessModalCreateProductProps> = ({
  visible,
  onClose,
  backScreen,
  newProduct
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ zIndex: 910 }}>
      <Modal
        visible={visible}
        contentStyle={{
          padding: "60px",
          width: "600px",
          height: "405px",
          borderRadius: 25,
          position: "relative",
        }}
      >
        <header className="success__modal-header">
          <RoundedCloseButton onClick={() => onClose()} />
        </header>
        <main className="success__modal-main">
          <Check width={40} height={40} />
          <div className="success__modal-message">
            <h2>{t("managementDialogs.completed")}</h2>
            <span>{t("managementDialogs.productCreated")}</span>
          </div>
        </main>
        <footer className="success__modal-button-container">
          <ButtonOnlyTitle title={t("managementDialogs.backMain")} theme="light" onClick={() => backScreen()} />
          <ButtonOnlyTitle title={t("managementDialogs.anotherProduct")} theme="info" onClick={() => newProduct()} />
        </footer>
      </Modal>
    </div>
  );
};

export const DeleteModalCreateProduct: React.FC<DeleteModalCreateProductProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <AlertModal visible={visible} contentStyle={deleteModalContentStyle}>
      <section className="formDeleteProduct">
        <div className="close">
          <RoundedCloseButton onClick={onClose} />
        </div>
        <Check width={40} height={40} />

        <div className="infoModal">
          <TitleModal>{t("managementDialogs.areYouSure")}</TitleModal>
          <TextModal>{t("managementDialogs.deleteProductWarning")}</TextModal>
        </div>

        <div className="buttons-controll">
          <ButtonWithChildren onClick={onConfirm}>
            <div className="buttonWithChildren--content-inline">
              <PositiveIcon />
              <h6>{t("commonUi.yes")}</h6>
            </div>
          </ButtonWithChildren>
          <ButtonWithChildren onClick={onClose}>
            <div className="buttonWithChildren--content-inline">
              <NegativeIcon />
              <h6>{t("commonUi.no")}</h6>
            </div>
          </ButtonWithChildren>
        </div>
      </section>
    </AlertModal>
  );
};
